module.exports = __webpack_public_path__ + "media/newstyle/images/Componente 7 – 2-4845e59badb8e58f803d539c6349c3fd.svg";